const STORAGE_KEY = "industryCategorySuggestions";

function readAll() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : {};
  } catch {
    return {};
  }
}

function writeAll(data) {
  localStorage.setItem(STORAGE_KEY, JSON.stringify(data));
}

function normalizeInputs(name, description) {
  return {
    name: String(name ?? "").trim(),
    description: String(description ?? "").trim(),
  };
}

function inputsMatch(entry, name, description) {
  return entry?.name === name && entry?.description === description;
}

export function getCachedIndustryCategorySuggestion(userId, name, description) {
  if (!userId) return null;

  const { name: trimmedName, description: trimmedDescription } = normalizeInputs(name, description);
  if (!trimmedName || !trimmedDescription) return null;

  const entry = readAll()[userId];
  if (!inputsMatch(entry, trimmedName, trimmedDescription)) return null;

  return {
    industry: entry.industry ?? null,
    category: entry.category ?? null,
    found: Boolean(entry.found),
  };
}

export function saveCachedIndustryCategorySuggestion(
  userId,
  { name, description, industry = null, category = null, found = false }
) {
  if (!userId) return;

  const { name: trimmedName, description: trimmedDescription } = normalizeInputs(name, description);
  if (!trimmedName || !trimmedDescription) return;

  const all = readAll();
  all[userId] = {
    name: trimmedName,
    description: trimmedDescription,
    industry,
    category,
    found: Boolean(found),
  };
  writeAll(all);
}
